/* eslint-disable no-console */
import _get from 'lodash/get'
import _each from 'lodash/each'
import _isNil from 'lodash/isNil'
import _isEmpty from 'lodash/isEmpty'

const scriptsForLoad = {}

// Create mock Amplitude in development environment only if it doesn't exist
// This prevents the Gatsby error in localHost caused by GTM attemtping to access the window.amplitude object before it's loaded
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && !window.amplitude) {
  // Mock implementation of commonly used Amplitude methods
  window.amplitude = {
    add: (...args) => {
      console.log('[Mock Amplitude] add called with:', args)
      return { promise: () => {} }
    },
    identify: (...args) => {
      console.log('[Mock Amplitude] identify called with:', args)
    },
    logEvent: (...args) => {
      console.log('[Mock Amplitude] logEvent called with:', args)
    },
    setUserId: (...args) => {
      console.log('[Mock Amplitude] setUserId called with:', args)
    },
    setUserProperties: (...args) => {
      console.log('[Mock Amplitude] setUserProperties called with:', args)
    },
    // Add any other Amplitude methods you need to mock
  }
}

const loadScript = (url, props = {}, reload = false) => {
  if (!_get(scriptsForLoad, [url], false) || reload === true) {
    scriptsForLoad[url] = new Promise((resolve, reject) => {
      const script = document.createElement('script')

      _each(props, (value, key) => {
        if (!_isNil(value) && !_isEmpty(value)) {
          script.setAttribute(key, value)
        }
      })
      Object.assign(script, {
        type: 'text/javascript',
        src: url,
        async: true,
        onload: () => {
          resolve(script)
        },
        onerror: err => {
          reject(err)
        },
      })
      document.head.appendChild(script)
    })
  }
  return scriptsForLoad[url]
}

export default loadScript
